var map = {
	"./demo/04-forest.json": 85,
	"./demo/05-hospital.json": 86,
	"./demo/chalet.json": 87,
	"./demo/cliff.json": 88,
	"./demo/forest.json": 89,
	"./demo/start.json": 90,
	"./splash/start.json": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;